import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addQualityRating } from "../../../store/actions"
import { useEffect } from "react"

const AddQualityRating = props => {
  const dispatch = useDispatch()
  document.title = "Add Quality Rating"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      quality_rating: "",
    },
    validationSchema: Yup.object({
        quality_rating: Yup.string().required(
        "Please Enter Quality Rating"
      ),
    }),
    onSubmit: values => {
      dispatch(addQualityRating(values, props.history))
    },
  })

  const qualityRatings = useSelector(state => state.QualityRating)
  const { error } = useSelector(state => ({
    error: state.QualityRating.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Quality Rating" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="form"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="rating">
                            Quality Rating
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="quality_rating"
                            className={
                              validation.touched.quality_rating &&
                              validation.errors.quality_rating
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="rating"
                            placeholder="Enter Quality Rating"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.quality_rating || ""}
                          />
                          {validation.touched.quality_rating &&
                          validation.errors.quality_rating ? (
                            <FormFeedback type="invalid">
                              {validation.errors.quality_rating}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {qualityRatings && qualityRatings.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddQualityRating
